(() => {
  const code = 'JONELIA10';
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let timer;
  const boxes = () => [...document.querySelectorAll('[data-jon-weekly]')];
  const request = async (path, body) => {
    const response = await fetch(root + path, {credentials:'same-origin',headers:{'Accept':'application/json','Content-Type':'application/json'},...(body ? {method:'POST',body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Cart request failed');
    return data;
  };
  const isCode = value => String(value).toUpperCase() === code;
  function paint(cart) {
    const codes = cart.discount_codes || [];
    const entry = codes.find(d => isCode(d.code));
    const selected = cart.attributes?._jon_weekly_optin === '1' || !!entry;
    const count = cart.items.reduce((sum,item) => sum + (item.gift_card || item.selling_plan_allocation ? 0 : item.quantity),0);
    boxes().forEach(box => {
      if (Date.now() >= Date.parse(box.dataset.expiry)) { box.hidden = true; return; }
      box.querySelector('input').checked = selected;
      box.querySelector('progress').value = Math.min(count,3);
      box.querySelector('[role="status"]').textContent = entry?.applicable ? box.dataset.active : count < 3 ? (selected ? box.dataset.saved + ' ' : '') + box.dataset.remaining.replace('[count]',3-count) : selected ? box.dataset.conflict : box.dataset.ready;
    });
  }
  function enqueue(task) {
    queue = queue.catch(() => {}).then(task);
    return queue;
  }
  function sync() {
    if (!boxes().length) return;
    enqueue(async () => {
      try { paint(await request('cart.js')); } catch (_) {}
    });
  }
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-weekly-toggle]');
    if (!input) return;
    const selected = input.checked;
    boxes().forEach(box => { box.querySelector('input').disabled = true; box.querySelector('[role="status"]').textContent = box.dataset.loading; });
    enqueue(async () => {
      try {
        const current = await request('cart.js');
        const codes = (current.discount_codes || []).map(d => d.code).filter(c => !isCode(c));
        if (selected) codes.push(code);
        const updated = await request('cart/update.js',{discount:codes.join(','),attributes:{_jon_weekly_optin:selected ? '1' : ''}});
        paint(updated);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));
      } catch (_) {
        boxes().forEach(box => {box.querySelector('input').checked = !selected;box.querySelector('[role="status"]').textContent = box.dataset.error;});
      } finally { boxes().forEach(box => { box.querySelector('input').disabled = false; }); }
    });
  });
  const schedule = () => { clearTimeout(timer); timer = setTimeout(sync,150); };
  ['cart:rerendered','product:added'].forEach(name => document.addEventListener(name,schedule,true));
  document.addEventListener('shopify:section:load',sync);
  window.addEventListener('pageshow',sync);
  function tick() {
    const now = Date.now();
    boxes().forEach(box => {
      const remaining = Math.max(0, Math.floor((Date.parse(box.dataset.expiry) - now) / 1000));
      if (!Number.isFinite(remaining)) return;
      if (remaining === 0) {
        box.hidden = true;
        const stage = box.closest('.jon-weekly-stage');
        if (stage) stage.hidden = true;
        return;
      }
      const timer = box.querySelector('[data-weekly-timer]');
      if (!timer) return;
      timer.hidden = false;
      const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
      Object.entries(values).forEach(([key,value]) => {
        const node = timer.querySelector('[data-clock="'+key+'"]');
        const text = String(value).padStart(2,'0');
        if (node.textContent !== text) node.textContent = text;
      });
    });
  }
  tick();
  setInterval(() => {if (!document.hidden) tick();},1000);
  document.addEventListener('visibilitychange',tick);
  document.addEventListener('cart:rerendered',tick,true);
  document.addEventListener('shopify:section:load',tick);
  sync();
})();
